import React, {useContext, useEffect, useState} from 'react';
import { useParams } from 'react-router';
import { Panel } from '../../components/Panel';
import CompanyUserForm from '../../components/CompanyUserForm';
import IconComponent from '../../components/IconComponent';
import { ModelUser } from '@dia-ui/util_interlink-api';
import { Alert } from '../../components/Alert';
import {AppContext} from "../../context/AppContext";

export function CompanyUserEdit() {
  const {
    services: {
      serviceUser
    },
    getRoutes,
    I18N
  } = useContext(AppContext);

  const ROUTE_CONFIG = getRoutes();
  const { id } = useParams();
  const [user, setUser] = useState<ModelUser | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (id) {
          const fetchedUser: ModelUser = await serviceUser.getById(id);
          setUser(fetchedUser);
        }
      } catch (error) {
        console.error('Fehler beim Laden des Benutzers:', error);

        setError(I18N.t('Fehler beim Laden des Benutzers. Bitte versuchen Sie es später erneut.'));
      }
    };

    fetchUser();
  }, [id, serviceUser]);

  return (
        <>
          {error && <Alert message={error} />}
          <Panel
            header={
              <>
                <IconComponent iconName={ ROUTE_CONFIG.COMPANY_USER_VIEW_EDIT.icon } />
                { ROUTE_CONFIG.COMPANY_USER_VIEW_EDIT.title }
              </>
            }
          >
            <CompanyUserForm user={user} />
          </Panel>
        </>
  );
}
